// 自定义table
<template>
  <div class="customTable-wrap">
    <el-table class="table" ref="customTable" v-bind="$attrs" :data="tableData" v-on="$listeners" :cell-class-name="handleCell"  :header-cell-class-name="handleHeaderCell" >
      <template v-for="(item, index) in column">
        <!-- 正常表格项 -->
        <el-table-column
            v-if="isNullFun(item.slotName) && isNullFun(item.render) && isNullFun(item.slotHeader)"
            v-bind="item"
            :key="index + '_' + item.prop"
            :align="item.align | alignFilter"
        >
        </el-table-column>
        <!--  只有render -->
        <el-table-column
            v-if="isNullFun(item.slotName) && !isNullFun(item.render) && isNullFun(item.slotHeader)"
            v-bind="item"
            :key="index + '_' + item.prop"
            :align="item.align | alignFilter"
        >
          <template slot-scope="scope">
            <ex-slot
                :column="item"
                :index="index"
                :render="item.render"
                :row="scope.row"
            />
          </template>
        </el-table-column>
        <!--  只有 slotHeader-->
        <el-table-column
            v-if="isNullFun(item.slotName) && isNullFun(item.render) && !isNullFun(item.slotHeader)"
            v-bind="item"
            :key="index + '_' + item.prop"
            :align="item.align | alignFilter"
        >
          <template slot="header" slot-scope="scope">
            <slot :name="item.slotHeader" :row="scope.column" :index="scope.$index"></slot>
          </template>
        </el-table-column>
        <!-- 只有 slotName -->
        <el-table-column
            v-if="!isNullFun(item.slotName) && isNullFun(item.slotHeader) && isNullFun(item.render)"
            :key="index + '_' + item.prop"
            v-bind="item"
            :align="item.align | alignFilter"
        >
          <template slot-scope="scope">
            <slot :name="item.slotName" :row="scope.row" :index="scope.$index"></slot>
          </template>
        </el-table-column>
        <!--  render 和 slotHeader-->
        <el-table-column
            v-if="isNullFun(item.slotName) && !isNullFun(item.render) && !isNullFun(item.slotHeader)"
            v-bind="item"
            :key="index + '_' + item.prop"
            :align="item.align | alignFilter"
        >
          <template v-if="!isNullFun(item.slotHeader)" slot="header" slot-scope="scope">
            <slot :name="item.slotHeader" :row="scope.column" :index="scope.$index"></slot>
          </template>
          <template slot-scope="scope">
            <ex-slot
                :column="item"
                :index="index"
                :render="item.render"
                :row="scope.row"
            />
          </template>
        </el-table-column>
        <!-- slotName 和 slotHeader -->
        <el-table-column
            v-if="!isNullFun(item.slotName) && !isNullFun(item.slotHeader) && isNullFun(item.render)"
            :key="index + '_' + item.prop"
            v-bind="item"
            :align="item.align | alignFilter"
        >
          <template slot="header" slot-scope="scope">
            <slot :name="item.slotHeader" :row="scope.column" :index="scope.$index"></slot>
          </template>
          <template slot-scope="scope">
            <slot :name="item.slotName" :row="scope.row" :index="scope.$index"></slot>
          </template>
        </el-table-column>
        <!-- 带转换方法 render slotName-->
        <el-table-column
            v-if="!isNullFun(item.slotName) && !isNullFun(item.render) && isNullFun(item.slotHeader)"
            v-bind="item"
            :key="index + '_' + item.prop"
            :align="item.align | alignFilter"
        >
          <template slot-scope="scope">
            <ex-slot
                :column="item"
                :index="index"
                :render="item.render"
                :row="scope.row"
            />
            <slot :name="item.slotName" :row="scope.row" :index="scope.$index"></slot>
          </template>
        </el-table-column>
        <!-- 带转换方法 render slotName slotHeader-->
        <el-table-column
            v-if="!isNullFun(item.slotName) && !isNullFun(item.render) && !isNullFun(item.slotHeader)"
            v-bind="item"
            :key="index + '_' + item.prop"
            :align="item.align | alignFilter"
        >
          <template v-if="!isNullFun(item.slotHeader)" slot="header" slot-scope="scope">
            <slot :name="item.slotHeader" :row="scope.column" :index="scope.$index"></slot>
          </template>
          <template slot-scope="scope">
            <ex-slot
                :column="item"
                :index="index"
                :render="item.render"
                :row="scope.row"
            />
            <slot :name="item.slotName" :row="scope.row" :index="scope.$index"></slot>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <!-- 分页 -->
    <div class="pagination-wrap" v-if="showPages">
      <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="pageSize"
          :total="total"
          :current-page="current"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
let exSlot = {
  functional: true,
  props: {
    row: Object,
    render: Function,
    index: Number,
    column: {
      type: Object,
      default: null,
    },
    showPages:{//是否显示分页
      type:Boolean,
      default:false
    }
  },
  render(h, data) {
    const params = {
      row: data.props.row,
      index: data.props.index,
    };
    if (data.props.column) params.column = data.props.column;
    return data.props.render(h, params);
  },
};

import {isNull,isFuntion,isArray,isEmptyArray,isNumber} from "@/utils/validateBase.js";

export default {
  name: "customTable",
  components: {exSlot},
  props: {
    size:{
      type:String,
      default:'medium'
    },
    // 是否显示分页信息
    showPages: {
      type: Boolean,
      default: false,
    },
    // 表头数据
    column: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    // 表格数据
    tableData: {
      type: Array,
      default() {
        return [];
      },
    },
    // 每页条数配置
    pageSize: {
      type: Array,
      default() {
        return [10, 20, 30, 40];
      },
    },
    // 总页数
    total: {
      type: Number,
      default() {
        return 0;
      },
    },
    // 当前页码
    currentPage: {
      type: Number,
      // required: true,
      default: 1
    },
  },
  filters: {
    /**
     * 没有设置align 默认为center
     * **/
    alignFilter(val) {
      if (isNull(val)) return "center";
      return val;
    },
  },
  watch: {
    /**
     * 根据总条数 计算总页数
     */
    total: {
      deep: true,
      immediate: true,
      handler(val) {
        this.pagesNumber = Math.ceil(val / this.perSize);
      },
    },
    /**
     * 每页条数配置 计算总页数
     * */
    pageSize: {
      deep: true,
      immediate: true,
      handler(val) {
        if (!isNull(val) && isArray(val) && !isEmptyArray(val)) {
          this.perSize = val[0] * 1;
          this.pagesNumber = Math.ceil(this.total / this.perSize);
        }
      },
    },
    /**
     * 页码监听
     * */
    currentPage: {
      deep: true,
      immediate: true,
      handler(val) {
        if (!isNull(val) && isNumber(val) && val !== this.current) {
          this.current = val
        }
      }
    },
  },
  data() {
    return {
      perSize: 10, // 每页条数
      current: 1, // 当前页码
      pagesNumber: 1, // 总页数
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {
    /**
     * 是否为空
     * str 数据
     * */
    isNullFun(str) {
      return isNull(str);
    },
    /**
     * 是否是方法
     * str 数据
     * */
    isFuntionFun(str) {
      return isFuntion(str);
    },
    /**
     * 分页数量点击事件
     * val 点击的页面
     * */
    handleSizeChange(val) {
      //   console.log(`每页 ${val} 条`);
      this.perSize = val;
      this.$emit("pageChange", {
        perSize: val,
        current: this.current,
      });
    },
    /**
     * 分页按钮点击事件
     * 切换后的页码
     * */
    handleCurrentChange(val) {
      //   console.log(`当前页: ${val}`);
      this.current = val;
      this.$emit("pageChange", {
        size: this.perSize,
        current: val,
      });
    },

    handleCell(){
      return `cell-${this.size}-section`
    },
    handleHeaderCell(){
      return `header-cell-${this.size}-section`
    }
  },
};
</script>
<style scoped lang="less">
  .pagination-wrap {
  padding: 20px 0 20px 20px;
  text-align: right;
}

::v-deep.el-table .cell-medium-section{
  padding: 5.5px 12px !important;
  font-size: 14px !important;
}
::v-deep.el-table .cell-small-section{
  padding: 3.5px 12px !important ;
  font-size: 14px !important;
}
 ::v-deep.el-table .header-cell-medium-section{
  background-color: #F0F1F3;
  color:#5A6678;
  padding: 8px 12px !important ;
  line-height: 23px !important ;
}
::v-deep.el-table .header-cell-small-section{
  padding: 6px 12px !important ;
  background-color: #F0F1F3;
  line-height: 23px !important ;
}


</style>
